import { useState } from "react";
import { motion } from "framer-motion";
import { useSwipeable } from "react-swipeable"; // Import swipeable
import images from "../../../images.config";
import icons from "../../../icons.config";
import GlobalButton from "../../GlobalButton";
import itemData from "../../dressData";
import { setClickedItem } from "../../../store/itemsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FOUNDER_IMAGE_URL, IMAGE_BASE_URL } from "../../../api-urls";

const Trends = ({ data, carouselData }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFading, setIsFading] = useState(false); // State for fading effect
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const imagess = [
  //   { image: images.trend1, title: 'Trend Wave 1', description: 'This is the latest trend wave of the season. Get it now!', cImage: images.trend1 },
  //   { image: images.trend2, title: 'Trend Wave 2', description: 'Stay ahead with Trend Wave 2. Perfect for any occasion.', cImage: images.trend2c },
  //   { image: images.trend3, title: 'Trend Wave 3', description: 'Upgrade your wardrobe with this exclusive trend!', cImage: images.trend3c },
  // ];
  // Handle Next with Fade Effect
  const handleNext = () => {
    setIsFading(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % totalImages);
      setIsFading(false);
    }, 700); // Timing to match fade effect duration
  };

  // Handle Back with Fade Effect
  const handleBack = () => {
    setIsFading(true);
    setTimeout(() => {
      setCurrentIndex(
        (prevIndex) => (prevIndex + totalImages - 1) % totalImages
      );
      setIsFading(false);
    }, 500);
  };
  const handlers = useSwipeable({
    onSwipedLeft: handleNext,
    onSwipedRight: handleBack,
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  const item = data;
  if (!data || data.length === 0) return null;

  // const defaultVariantImages = leftData?.defaultVariant?.variant_images || []; // Ensure it's an array
  const defaultVariantImages = Array.isArray(
    item[0]?.left?.data[0]?.default_variant?.images
  )
    ? item[0]?.left?.data[0].default_variant?.images
    : [];
  console.log("carousel data-------", data);
  console.log("Processed Default Variant Images:", defaultVariantImages);
  // const imagess = item[0]?.left?.data?.default_variant?.images;
  const imagess = item[0]?.left?.data[0]?.default_variant?.images ?? []; // Ensure it's always an array
  console.log("the trend waves images are .............", imagess);
  const description = item[0].right?.data?.description;
  console.log("Item object:", item);
  console.log("Right data:", item[0]?.right);
  console.log("Description:", item[0]?.right?.data?.description);

  const totalImages = imagess.length;

  const visibleImages = [
    imagess[currentIndex],
    imagess[(currentIndex + 1) % totalImages],
    imagess[(currentIndex + totalImages - 1) % totalImages],
  ];

  const positions = ["center", "right", "left"];
  const imageVariants = {
    center: { x: "0%", scale: 1, zIndex: 5 },
    right: { x: "30%", scale: 0.8, zIndex: 3 },
    left: { x: "-25%", scale: 0.8, zIndex: 3 },
  };

  const handleDressClick = (item) => {
    console.log("Item received in handleitemClick:", item); // Debug here
    if (!item) {
      console.error("Item is undefined or null");
      return;
    }
    dispatch(setClickedItem(item));
    navigate("/view");
  };

  const visibleItems = 1; // Assuming 1 visible item on smaller screens
  const numberOfDots = Math.ceil(imagess.length / visibleItems);

  const handleDotClick = (dotIndex) => {
    setCurrentIndex(dotIndex * visibleItems);
  };

  const goToShop = () => {
    navigate("/shop");
  };

  return (
    <>
      <section className="bg-tertiary overflow-hidden ">
        <div className="hidden lg:block relative lg:-right-0 lg:top-0 lg:left-[80%] xl:top-0 z-20">
          <img src={icons.trendCircles} alt="Doodle Left" className="w-1/5" />
        </div>
        <div className="hidden lg:inline relative lg:left-[4%] bottom-40 z-20">
          <img
            src={icons.collectionFlower}
            alt="Doodle Left"
            className="lg:w-24"
          />
        </div>
        <div className="lg:hidden relative -right-0 left-[60%] md:left-[62%] z-10">
          <img
            src={icons.trendCircles}
            alt="Doodle Left"
            className="w-2/5 md:w-2/5"
          />
        </div>
        <div className="lg:hidden relative left-[5%] md:bottom-52 bottom-24 z-10">
          <img
            src={icons.collectionFlower}
            alt="Doodle Left"
            className="w-16 md:w-20"
          />
        </div>

        <div
          {...handlers}
          className="bg-tertiary flex flex-col lg:flex-row py-[23%]  md:pt-[2%] md:pb-[30%] lg:pb-0 lg:py-0 xl:pb-0  relative top-6 md:top-60 lg:-top-24 xl:-top-40 2xl:-top-44 z-10"
        >
          {/* Carousel Section */}
          <h3 className="text-2xl md:text-4xl lg:hidden text-primary1 font-outfit font-light relative -top-48 md:-top-96  z-10 mb-20 text-center ">
            TREND WAVES
          </h3>

          <div className="bg-tertiary relative w-full lg:w-1/2 flex items-center justify-center left-[4%] bottom-0">
            {/* Heading above the image for small and medium screens */}

            {/* Left Arrow */}
            <img
              src={icons.arrowLeft}
              alt="left arrow"
              className="absolute left-[8%] top-1/2 transform -translate-y-1/2 rounded-full h-11 w-11 z-20 cursor-pointer hidden lg:block p-1"
              onClick={handleBack}
            />
            {/* {visibleImages.map((image, index) => ( */}
            {data[0].left.data.map(
              (image, index) => (
                console.log(image),
                (
                  <motion.div
                    key={index}
                    className={`relative ${
                      isFading ? "opacity-0" : "opacity-100"
                    } transition-opacity duration-500`}
                    initial="center"
                    animate={positions[index]}
                    variants={imageVariants}
                    transition={{ duration: 0.8 }}
                    style={{ width: "65%", position: "absolute" }}
                  >
                    <img
                      src={
                        index === 0
                          ? FOUNDER_IMAGE_URL +
                              image.default_variant.images[0] ||
                            // ? FOUNDER_IMAGE_URL + defaultVariantImages[0] ||
                            "fallback-image.jpg"
                          : image
                      }
                      title={item.left?.data?.product_name}
                      className=" hidden lg:block lg:h-screen object-cover xl:py-12 xl:px-4 relative left-3"
                      alt={`Carousel ${item.left?.data?.product_name}`}
                    />
                    {/* Conditionally render text and button if the image is in the center */}
                    {index === 0 && (
                      <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col lg:justify-end top-20 md:top-60 lg:bottom-16 lg:left-8 items-start lg:ml-5 -ml-5 ">
                        <h3 className="text-lg lg:text-xl font-normal font-outfit text-primary1">
                          {item.left?.data?.product_name}
                        </h3>
                        {/* <p className="mt-2 text-sm">{image.description}</p> */}
                        <button className=" py-1 px-4 mb-4 mt-3 flex hover:text-hcolor font-outfit font-medium bg-hcolor text-primary2 hover:bg-tertiary transition-all duration-500 ease-in-out ">
                          <GlobalButton label="BUY" routeName="viewDress" />
                        </button>
                      </div>
                    )}
                  </motion.div>
                )
              )
            )}
            <motion.div
              key={currentIndex}
              className={`relative ${
                isFading ? "opacity-0" : "opacity-100"
              } transition-opacity duration-500`}
              initial="center"
              animate="center"
              transition={{ duration: 0.8 }}
              style={{ width: "79%", position: "absolute" }}
            >
              {imagess?.length > 0 ? (
                imagess.map((img, idx) => (
                  <img
                    key={idx}
                    src={FOUNDER_IMAGE_URL + img.image}
                    // className={idx === currentIndex ? "center-image" : "side-image"}
                    title={imagess[currentIndex].title || "Image"}
                    className={`${
                      idx === currentIndex ? "center-image" : "side-image"
                    } h-full w-full lg:hidden object-cover relative right-3`}
                    alt={`Carousel ${imagess[currentIndex].title || "Image"}`}
                  />
                ))
              ) : (
                <p>Loading...</p> // Display a placeholder or fallback UI
              )}
            </motion.div>
            {/* Right Arrow */}
            <img
              src={icons.arrowRight}
              alt="right arrow"
              className="absolute right-[2%] top-1/2 transform -translate-y-1/2 rounded-full h-11 w-11 z-20 cursor-pointer hidden lg:block p-1"
              onClick={handleNext}
            />
          </div>
          {/* Dot Indicators */}
          <div className="flex justify-center pt-8 z-10 lg:hidden relative top-44 md:top-96 md:mb-12">
            {Array.from({ length: numberOfDots }).map((_, dotIndex) => (
              <button
                key={dotIndex}
                onClick={() => handleDotClick(dotIndex)}
                className={`w-2 h-2 md:h-3 md:w-3 mx-2 rounded-full 
        ${
          dotIndex === Math.floor(currentIndex / visibleItems)
            ? "bg-primary1"
            : "bg-white border border-primary1"
        } 
        shadow-lg`}
              />
            ))}
          </div>

          {/* Text Section */}
          <div className="w-full lg:w-1/2 flex flex-col justify-center items-center lg:items-start lg:p-12 text-center lg:text-left relative lg:top-4 mt-56 md:mt-96 xl:h-screen lg:mt-0 lg:-right-0">
            <h3 className="hidden lg:block lg:text-3xl  text-primary1 font-outfit font-light relative bottom-24  lg:left-20">
              TREND WAVES
            </h3>
            <h2 className="text-2xl lg:text- font-normal font-outfit text-primary1  px-3 relative bottom-7 lg:bottom-5 xl:bottom-8 left-0 lg:left-16 md:mb-6 lg:mb-0 ">
              STAY AHEAD OF THE FASHION CURVE
            </h2>
            <p className="text-sm lg:text-base text-hcolor font-poppins font-light pr-8 pl-12 lg:px-20 text-start relative top-3">
              {description}
            </p>
            <div className="flex justify-center  mt-9  lg:pl-20 pb-4 relative lg:top-0 xl:top-20">
              <button className="border-2 py-3 px-7 flex bg-hcolor text-tertiary font-outfit font-medium hover:bg-tertiary hover:text-hcolor transition-all duration-500 ease-in-out">
                <GlobalButton
                  label="TRENDS"
                  routeName="shop"
                  onClick={goToShop}
                />
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Trends;
